import { AgeCategory } from '../../../models/AgeCategory';
import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

export const AGE_CATEGORY_SEARCH_PARAM = 'ageCategory';

export const useAgeCategorySearchParam = () => {
    const [searchParams] = useSearchParams();

    const ageCategory = searchParams.get(AGE_CATEGORY_SEARCH_PARAM);

    return useMemo(() => {
        switch (ageCategory) {
            case AgeCategory.ADULT:
                return { raw: ageCategory, value: AgeCategory.ADULT, searchParam: AgeCategory.ADULT };
            case AgeCategory.YOUNG_ADULT:
                return { raw: ageCategory, value: AgeCategory.YOUNG_ADULT, searchParam: AgeCategory.YOUNG_ADULT };
            case AgeCategory.CHILDREN:
                return { raw: ageCategory, value: AgeCategory.CHILDREN, searchParam: AgeCategory.CHILDREN };
            default:
                return { raw: ageCategory, value: AgeCategory.ALL_AGES, searchParam: undefined };
        }
    }, [ageCategory]);
};
